import React from "react";

import classes from "./Backdrop.module.css";

const Backdrop = ({ isActive, clicked }) => {
  return isActive ? (
    <div className={classes.backdrop} onClick={clicked}></div>
  ) : null;
};

export default Backdrop;
